<template>
<div>
    <h1>Historial de Pagos</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group>
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <a-month-picker :disabled-date="disabledDate" @change="changePeriod" :v-model="periodo" placeholder="Seleccionar periodo" />
          <b-button @click="searchPaymentByPeriod()">Buscar</b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getPaymentsHistory"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      bordered
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(amount)="row">
        {{ '$'+ row.item.amount + ' MXN' }}
      </template>
      <template v-slot:cell(card)="row">
        <div v-if="row.item.transaction && row.item.type == 'CARD'">
           {{ row.item.transaction.card_type_name }} con terminación {{ row.item.transaction.req_card_number.replace(/x/g, '') }}
        </div>
      </template>
      <template v-slot:cell(periodos)="row">
        {{ replaceMonth(row.item.concesiones[0].periodos[row.item.concesiones[0].periodos.length - 1]) }}
      </template>
      <template v-slot:cell(status)="row">
        <div :class="statusDictionary[row.item.status].class">{{ statusDictionary[row.item.status].label }}</div>
      </template>
      <template v-slot:cell(acciones)="row">
        <b-button variant="success" v-if="row.item.status == 'AUTH_REQUIRED'" @click="authorizeRedirect(row.item.pk, row.item.idTransaction)" size="sm" class="mb-1 w-100">
          <b-spinner v-if="cancelingPayment" small type="grow"></b-spinner>
          Ir a Autorizar
        </b-button>
        <b-button :disabled="cancelingPayment" variant="success" v-if="row.item.status == 'PENDING_CONFIRMATION'" @click="resumePayment(row.item)" size="sm" class="mb-1 w-100">
          Continuar Pago
        </b-button>
        <b-button :disabled="cancelingPayment" variant="success" v-if="row.item.status === 'PENDING_OXXO'" @click="viewPaymentInvoice(row.item.paymentURL)" size="sm" class="mb-1 w-100">
          Ver referencia de pago
        </b-button>
        <b-button :disabled="cancelingPayment" variant="danger" v-if="row.item.status === 'PENDING_OXXO'" @click="cancelPayment(row.item.pk, row.item.idTransaction)" size="sm" class="mb-1 w-100">
          <b-spinner v-if="cancelingPayment" small label="Spinning" class="fix-position"></b-spinner>
          Cancelar Pago
        </b-button>
        <b-button :disabled="cancelingPayment" variant="danger" v-if="row.item.status == 'PENDING_CONFIRMATION'" @click="cancelPayment(row.item.pk, row.item.idTransaction)" size="sm" class="mb-1 w-100">
          <b-spinner v-if="cancelingPayment" small type="grow"></b-spinner>
          Cancelar Pago
        </b-button>
        <b-button :disabled="cancelingPayment" variant="danger" v-if="row.item.status == 'AUTH_REQUIRED'" @click="cancelPaymentAuth(row.item.pk, row.item.idTransaction)" size="sm" class="mb-1 w-100">
          <b-spinner v-if="cancelingPayment" small type="grow"></b-spinner>
          Cancelar Pago
        </b-button>
        <b-button size="sm" @click="row.toggleDetails" class="mb-1 w-100">
          {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} Detalles
        </b-button>
      </template>
      <template #row-details="row">
        <b-table
          :items="row.item.concesiones"
          small
          borderless
          :fields="[
            { key: 'concesionNumber', label: 'No. Concesion' },
            { key: 'amount', label: 'Monto' },
            { key: 'periodos', label: 'Periodos' },
            { key: 'vehicleBrand', label: 'Vehiculo' },
            { key: 'licensePlate', label: 'Placa' }
          ]"
          >
          <template v-slot:cell(amount)="row">
            {{ '$'+ row.item.amount + ' MXN' }}
          </template>
          <template v-slot:cell(periodos)="row">
            {{ row.item.periodos.map(p => replaceMonth(p)).join(',') }}
          </template>
          <template v-slot:cell(vehicleBrand)="row">
            <div v-if="row.item.vehicle">
              {{ row.item.vehicle.brand + ' ' + row.item.vehicle.model }}
            </div>
          </template>
          <template v-slot:cell(licensePlate)="row">
            <div v-if="row.item.vehicle">
              {{ row.item.vehicle.licensePlate }}
            </div>
          </template>
        </b-table>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          align="right"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
</template>

<script>
// import { encrypt } from '@/config/headers'
import moment from 'moment'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import config from '../../../environmentConfig.json'
// import * as secrets from '@/services/secrets'
import crypto from 'crypto-js'
const GET_PAYMENT_HISTORY = gql`
  query getPaymentsHistory($rfc: String){
    getPaymentsHistory(rfc: $rfc){
      paidBy
      paymentDate
      createdAt
      pk
      type
      paymentURL
      transaction {
        card_type_name
        req_card_number
      }
      idTransaction
      concesiones{
        concesionNumber
        periodos
        vehicle {
          brand
          licensePlate
          model
        }
        amount
      }
      amount
      successful
      status
    }
  }
`
const GET_CONCECIONARIO_BY_ID = gql`
  query getConcesionarioId($id: Int) {
    getConcesionarioId(id: $id){
      id
      name
      automaticPayment
      cardId
      address {
        state
        city
        postalCode
        street
        suburb
        extNumber
        intNumber
      }
    }
  }
`
const GET_PAYMENT_HISTORY_BY_PERIOD = gql`
  query getPaymentsHistoryByPeriod($rfc: String, $periodo: String){
    getPaymentsHistoryByPeriod(rfc: $rfc periodo: $periodo){
      paidBy
      paymentDate
      createdAt
      idTransaction
      pk
      transaction {
        card_type_name
        req_card_number
      }
      concesiones{
        concesionNumber
        periodos
        vehicle {
          brand
          licensePlate
          model
        }
        amount
      }
      amount
      successful
      status
    }
  }
`

const CANCEL_PAYMENT = gql`
  mutation cancelTransaction($cancelTransactionInput: cancelTransactionInput) {
    cancelTransaction(cancelTransactionInput: $cancelTransactionInput) {
      message
    }
  }
`
const CANCEL_PAYMENT_AUTH = gql`
  mutation cancelTransactionAuth($cancelTransactionAuthInput: cancelTransactionAuthInput){
    cancelTransactionAuth(cancelTransactionAuthInput: $cancelTransactionAuthInput) {
      message
    }
  }
`
export default {
  data() {
    return {
      concesionario: {},
      fields: [
        { key: 'idTransaction', label: 'ID Transacción' },
        { key: 'type', label: 'Método de pago' },
        { key: 'paidBy', label: 'Responsable de Pago' },
        { key: 'paymentDate', label: 'Fecha' },
        { key: 'amount', label: 'Monto' },
        { key: 'card', label: 'Tarjeta' },
        { key: 'periodos', label: 'Periodo' },
        { key: 'status', label: 'Estado' },
        'acciones',
      ],
      autoRefresh: true,
      statusDictionary: {
        ACCEPTED_COMPLETED: { label: 'Pago exitoso', class: 'text-success font-weight-bold' },
        PENDING_CONFIRMATION: { label: 'Pendiente de confirmación', class: 'text-warning font-weight-bold' },
        PENDING_AUTH: { label: 'Autenticando...', class: 'text-warning font-weight-bold' },
        AUTH_REQUIRED: { label: 'Autorización requerida', class: 'text-warning font-weight-bold' },
        ACCEPTED_PROCESSING: { label: 'Pago aceptado (Procesando...)', class: 'text-warning font-weight-bold' },
        FAILED_REJECTED: { label: 'Pago fallido', class: 'text-danger font-weight-bold' },
        FAILED_EXPIRED: { label: 'Pago expirado', class: 'text-danger font-weight-bold' },
        FAILED_CANCELLED_BY_USER: { label: 'Pago cancelado', class: 'text-danger font-weight-bold' },
        FAILED_CANCELLED_BY_USER_AUTH: { label: 'Pago cancelado', class: 'text-danger font-weight-bold' },
        PENDING_RECEIVED: { label: 'Procesando pago...', class: 'text-warning font-weight-bold' },
        PENDING_OXXO: { label: 'Pendiente de pago', class: 'text-warning font-weight-bold' },
      },
      cancelingPayment: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idConcesionAction: null,
      dataLoad: -1,
      getPaymentsHistory: [],
      periodo: {},
      months: {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      },
    }
  },
  /* apollo: {
    getPaymentsHistory: {
      query: GET_PAYMENT_HISTORY,
      context: headers(),
      variables () {
        return {
          rfc: this.$store.state.user.rfc,
        }
      },
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data }) {
        // console.log(data)
        if (data.getPaymentsHistory) {
          console.log(data.getPaymentsHistory)
          this.getPaymentsHistory.sort((a, b) => {
            // console.log(new Date(a.createdAt), new Date(b.createdAt))
            return new Date(b.createdAt) - new Date(a.createdAt)
          })
          // console.log(this.getPaymentsHistory)
          this.totalRows = data.getPaymentsHistory.length
        }
      },
    },
  }, */
  created: function () {
    this.dataLoad = parseInt(this.getFranchisee)
    // console.log(this.$apollo.queries)
  },
  mounted() {
    this.$apollo.query({
      query: GET_CONCECIONARIO_BY_ID,
      context: headers(),
      variables: {
        id: parseInt(this.$store.state.user.franchisee),
      },
    })
      .then(({ data }) => {
        this.concesionario = data.getConcesionarioId
      })
      .catch(e => {
        console.log(e)
      })
    this.queryPaymentsHistory(0.5)
  },
  methods: {
    cancelPayment(rfc, idTransaction) {
      this.autoRefresh = false
      this.cancelingPayment = true
      setTimeout(() => {
        const cancelT = {
          rfc: rfc,
          transactionId: idTransaction,
        }
        this.$apollo.mutate({
          mutation: CANCEL_PAYMENT,
          context: headers(),
          variables: {
            cancelTransactionInput: cancelT,
          },
        }).then(data => {
          this.autoRefresh = true
          if (data.data.cancelTransaction.message.split(':')[0] === 'SUCCESS') {
            alert('Pago cancelado con éxito')
          } else {
            alert('No fue posible cancelar tu pago')
          }
          this.cancelingPayment = false
        }).catch(e => console.log(e))
      }, 1000)
    },
    cancelPaymentAuth(rfc, idTransaction) {
      this.cancelingPayment = true
      this.autoRefresh = false
      const cancelT = {
        rfc: rfc,
        transactionId: idTransaction,
      }
      this.$apollo.mutate({
        mutation: CANCEL_PAYMENT_AUTH,
        context: headers(),
        variables: {
          cancelTransactionAuthInput: cancelT,
        },
      }).then(data => {
        this.autoRefresh = true
        if (data.data.cancelTransactionAuth.message.split(':')[0] === 'SUCCESS') {
          alert('Pago cancelado con éxito')
        } else {
          alert('No fue posible cancelar tu pago')
        }
        this.cancelingPayment = false
      }).catch(e => console.log(e))
    },
    queryPaymentsHistory(interval) {
      if (interval > 14) {
        interval = 15
      } else {
        interval = interval * 2
      }
      if (this.autoRefresh) {
        this.$apollo.query({
          query: GET_PAYMENT_HISTORY,
          context: headers(),
          variables: {
            rfc: this.$store.state.user.rfc,
          },
        }).then(({ data }) => {
          // console.log(data)
          if (data.getPaymentsHistory) {
            this.getPaymentsHistory = data.getPaymentsHistory.sort((a, b) => {
              // console.log(new Date(a.createdAt), new Date(b.createdAt))
              return new Date(b.createdAt) - new Date(a.createdAt)
            })
            this.getPaymentsHistory = data.getPaymentsHistory
            // console.log(this.getPaymentsHistory)
            this.totalRows = data.getPaymentsHistory.length
            setTimeout(() => this.queryPaymentsHistory(interval), interval * 1000)
          }
        })
      } else {
        interval = 0.5
        setTimeout(() => this.queryPaymentsHistory(interval), interval * 1000)
      }
    },
    authorizeRedirect(rfc, idTransaction) {
      const authorizeUrl = `${config[process.env.NODE_ENV].securePayment}authRequired/${rfc}/${idTransaction}`
      window.location.href = authorizeUrl
    },
    resumePayment(item) {
      const paymentResume = {
        idTransaction: item.idTransaction,
        concesionario: {
          rfc: item.pk,
          name: this.$store.state.user.name,
          email: this.$store.state.user.email,
        },
        totalAmount: item.amount,
        concesiones: item.concesiones,
        timestamp: new Date().toISOString(),
        address: this.concesionario.address,
      }
      console.log('===========================>', paymentResume)
      // secrets.retrieveSecretCybersource().then(s => {
      // console.log('S =====>', s)
      // const secretKey = JSON.parse(s).secret_key
      const secretKey = '6cb5e758314b4d948a844d62139776ee20fb0e0cd6ed4fcbb1714f9510014ba7e5e92d8e0140475e8e0c6e40c8c0c776873c8db582b14e37b7feb1b66c629d683b8e4afa99d44bcc964df7c355683511b401b6ee59314397bef1adb3412856b0f0efced97a374631b94854a10bfc1487b467b1e62cd44382a76bc47a06ceecee'
      console.log('secretKey', secretKey)
      const paymentString = JSON.stringify(paymentResume)
      const encryptedPaymentDetails = crypto.AES.encrypt(paymentString, secretKey).toString()
      const urlService = `${config[process.env.NODE_ENV].securePayment}paymentConfirmationResume?payment=${encryptedPaymentDetails}`
      // const urlService = `http://localhost:4000/paymentConfirmation?payment=${encryptedPaymentDetails}`
      /* console.log(encryptedPaymentDetails)
      console.log(urlService) */
      window.location = urlService
      // }).catch(e => console.log(e))
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    disabledDate(current) {
      return current > moment().add(1, 'days')
    },
    viewPaymentInvoice(paymentURL) {
      window.open(paymentURL, '_blank')
    },
    searchPaymentByPeriod() {
      this.autoRefresh = false
      if (this.periodo === '' || typeof (this.periodo) === 'object') {
        this.autoRefresh = true
        this.queryPaymentsHistory(2)
      } else {
        this.$apollo.query({
          query: GET_PAYMENT_HISTORY_BY_PERIOD,
          context: headers(),
          variables: {
            rfc: this.$store.state.user.rfc,
            periodo: String(this.periodo).replace('-0', '-'),
          },
        })
          .then(({ data }) => {
            if (data.getPaymentsHistoryByPeriod) {
              // console.log(data)
              this.getPaymentsHistory = data.getPaymentsHistoryByPeriod
              this.totalRows = data.getPaymentsHistoryByPeriod.length
            } else {
              // this.$apollo.queries.getPaymentsHistory.refetch()
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    changePeriod(event) {
      if (event) {
        this.periodo = moment(new Date(event._d)).format('YYYY-M')
      } else {
        this.periodo = ''
      }
    },
    replaceMonth(date) {
      const month = this.months[date.split('-')[1]]
      const newDate = date.split('-')[0] + '-' + month
      return newDate
    },
  },
  computed: {
    getFranchisee() {
      return this.$store.state.user.franchisee
    },
  },
}
</script>
<style>
</style>
